import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=0366507c&scoped=true&lang=pug"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"
import style0 from "./Today.vue?vue&type=style&index=0&id=0366507c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366507c",
  null
  
)

export default component.exports